import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import CustomTextField from "../../components/ui/TextField";
import "./styles/loginForm.css";
import { useState } from "react";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { UserLogin } from "./api/loginApi";
import { toast } from "react-hot-toast";
import CustomToast from "../../components/ui/CustomToast";

const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [forgotError, setForgotError] = useState(false);
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const [error, setError] = useState({
    usernameError: "",
    passwordError: "",
  });

  const handleOnChangeEvent = (e) => {
    const { name, value, type, checked } = e?.target;
    if (name === "password") {
      let password = loginData?.password;
      if (!password) {
        setShowPassword(false);
      }
    }
    setError({
      usernameError: "",
      passwordError: "",
    });
    setForgotError(false);
    setLoginData((preData) => ({
      ...preData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleReset = () => {
    setError({
      usernameError: "",
      passwordError: "",
    });

    setForgotError(false);

    setLoginData({
      username: "",
      password: "",
      rememberMe: false,
    });
  };

  const handleSumbit = async () => {
    let hasError = false;

    try {
      if (loginData?.username === "") {
        setError((error) => ({
          ...error,
          usernameError: "Invalid Username",
        }));
        hasError = true;
      }

      if (loginData?.password === "") {
        setError((error) => ({
          ...error,
          passwordError: "Invalid Password",
        }));
        hasError = true;
      }

      if (hasError) return;
      const response = await UserLogin(loginData);
      if (response?.status === 200) {
        localStorage.setItem("token", response?.token);
        localStorage.setItem("role", response?.role?.roleName || response?.role);
        // The Select-local "Admin"/"Stock Manager" role above only governs
        // which of the Select screens someone can reach. Whether this person
        // is the actual super admin is a separate flag on their real role,
        // and is what gates screens like Report that everyone with Select
        // access should not see.
        localStorage.setItem(
          "isAdmin",
          String(!!response?.user?.role?.isAdmin)
        );
        navigate("/home");
      } else {
        console.error("there was a error logging in");
      }
    } catch (error) {
      if (error?.response?.data?.message === "User does not exist") {
        setError((error) => ({
          ...error,
          usernameError: "Invalid Username",
        }));
      } else if (error?.response?.data?.message === "Invalid user credentials") {
        setError((error) => ({
          ...error,
          passwordError: "Invalid Password",
        }));
      } else if (error?.response?.data?.message === "Please Contact Admin to assign role") {
        toast.custom((t) => (
          <CustomToast 
            t={t}
            message={"Contact Admin to assign role"}
            isError={true}
          />
        ))
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSumbit();
    }
  };

  const handleForgotPassword = () => {
    setForgotError(true);
  };

  // useEffect(()=>{
  //   const userData = JSON.parse(localStorage.getItem("userData"))
  //   const Selecttoken = JSON.parse(localStorage.getItem("token"))

  //   if(userData && Selecttoken){
  //     localStorage.setItem("token",userData.token)
  //     navigate("/home")
  //   }
  // },[])

  return (
    <>
      <Container>
        <Box className="login-box">
          {/* <Box className="logo-box">{<img src="/Logo.png" alt="Logo" />}</Box> */}
          <Box className="login-form" onKeyDown={handleKeyDown}>
            <Box
              className="custom-width"
              sx={
                error?.usernameError
                  ? { marginBottom: 0 }
                  : { marginBottom: 2.5 }
              }
            >
              <CustomTextField
                fullWidth
                id="username"
                name="username"
                size="small"
                label="Username"
                variant="standard"
                placeholder="Enter Your Username"
                helperText={error?.usernameError ? error?.usernameError : ""}
                value={loginData?.username}
                onChange={handleOnChangeEvent}
                autoComplete="off"
              />
            </Box>

            <Box
              className="custom-width"
              sx={
                error.passwordError
                  ? { marginBottom: 0, marginTop: 2.5 }
                  : { marginBottom: 2.5, marginTop: 2.5 }
              }
            >
              <CustomTextField
                fullWidth
                id="password"
                name="password"
                size="small"
                label="Password"
                variant="standard"
                placeholder="Enter Your Password"
                helperText={error?.passwordError ? error?.passwordError : ""}
                value={loginData?.password}
                onChange={handleOnChangeEvent}
                type={showPassword ? "text" : "password"}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        disableRipple
                        disableFocusRipple
                        aria-label="toggle password visibility"
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {loginData?.password === "" ? (
                          ""
                        ) : showPassword ? (
                          <VisibilityOutlined />
                        ) : (
                          <VisibilityOffOutlined />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <Box
              className="custom-width"
              sx={{ marginBottom: 2.5, marginTop: 3 }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {/* Remember Me Checkbox */}
                <FormControlLabel
                  control={
                    <Checkbox
                      name="rememberMe"
                      checked={loginData?.rememberMe}
                      onChange={handleOnChangeEvent}
                      sx={{
                        "& .css-1umw9bq-MuiSvgIcon-root": {
                          fontSize: "1.5vw",
                          marginRight: ".2vw",
                        },
                      }}
                    />
                  }
                  label="Remember Me"
                />

                {/* Forget Password Button */}
                <button
                  type="button"
                  className="custom-forgot-password"
                  onClick={handleForgotPassword}
                >
                  Forget Password?
                </button>
              </Box>

              {/* Error Message */}
              {forgotError && (
                <Box className="forgot-password-error">
                  Please contact the administrator to reset your password.
                </Box>
              )}
            </Box>

            <Box
              className="custom-width"
              sx={{
                marginTop: forgotError ? "1.5vw" : "1.5vw",
              }}
            >
              <Button
                type="button"
                variant="contained"
                fullWidth
                disableElevation
                onClick={handleSumbit}
                sx={{ textTransform: "none", width: "full" }}
              >
                Log-In
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default LoginScreen;
